export default async function resetNewBookmarksCount({ state }) {
  state.set(['newBookmarksCount'], 0);
  state.commit();
}
